import { ENDS, ETaxVariant } from 'cashbox';

import { ENTITIES_CONFIG } from '../constants';
import { ISetting, ITax } from '../interfaces';
import { getValue } from './getValue';

export const getTaxes = (settingValues: Array<ISetting>): Array<ITax> => {
  const taxes: Array<ITax> = [];

  for (const entityConfig of ENTITIES_CONFIG) {
    const nds = getValue(
      settingValues,
      entityConfig.ndsAlias,
      null
    ) as ENDS | null;
    const taxVariant = getValue(
      settingValues,
      entityConfig.variantAlias,
      null
    ) as ETaxVariant | null;

    const existingTax = taxes.find(
      (tax) => tax.nds === nds && tax.taxVariant === taxVariant
    );
    if (existingTax) {
      existingTax.entities?.push(entityConfig.entity);
      continue;
    }

    if (nds || taxVariant) {
      taxes.push({ nds, taxVariant, entities: [entityConfig.entity] });
    }
  }

  return taxes;
};
